import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { ArrowUpRight } from "lucide-react";

const DESSERTS = [
  { name: "Signature Sundaes", price: "from £10", desc: "Towering knickerbocker glories and banana splits, crowned with fresh cream and a wafer fan.", img: "/sundae-coupe.webp", pos: "object-[50%_48%]" },
  { name: "Waffles", price: "see menu", desc: "Baked to order, golden and crisp, with your choice of topping, soft vanilla and fresh cream.", img: "/waffle-real.webp" },
  { name: "Milkshakes", price: "from £6.60", desc: "Thick-spun the old-fashioned way, in frosted glasses with striped paper straws.", img: "/milkshake.webp", pos: "object-[50%_12%]" },
  { name: "Celebration Cakes", price: "made to order", desc: "Made to order for birthdays and anniversaries — the centrepiece of every celebration.", img: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?q=80&w=640&auto=format&fit=crop" },
  { name: "Seasonal Treats", price: "ask in parlour", desc: "Festive specials, Easter creations and summer-only delights, all year round.", img: "/seasonal-treat.jpg" },
];

const Desserts = () => (
  <section id="desserts" data-testid="desserts-section" className="py-28 md:py-36 bg-teal text-cream relative overflow-hidden">
    <div className="absolute inset-x-0 top-0 h-6 bg-cream" style={{ clipPath: "polygon(0 0, 100% 0, 100% 20%, 0 100%)" }} aria-hidden="true" />

    <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
      <SectionHeading chapter="03" overline="Sundaes & Desserts" title="Crafted to Be Remembered" dark />

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {DESSERTS.map((d, i) => (
          <Reveal key={d.name} delay={i * 0.08}>
            <article data-testid={`dessert-card-${i}`}
              className="group bg-teal-deep/60 border border-cream/10 rounded-[2rem] overflow-hidden hover:-translate-y-2 hover:border-gold/50 transition-[transform,border-color] duration-500 shadow-xl shadow-teal-deep/40">
              <div className="relative h-52 overflow-hidden">
                <img src={d.img} alt={d.name} loading="lazy"
                  className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ${d.pos || "object-center"}`} />
                <div className="absolute inset-0 bg-gradient-to-t from-teal-deep/80 to-transparent" />
                <span className="absolute bottom-4 left-5 font-display italic text-gold text-lg">{d.price}</span>
              </div>
              <div className="p-6 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display font-bold text-2xl text-cream">{d.name}</h3>
                  <p className="text-sm text-cream/70 mt-2 leading-relaxed">{d.desc}</p>
                </div>
                <span className="shrink-0 w-10 h-10 rounded-full border border-gold/60 grid place-items-center text-gold group-hover:bg-gold group-hover:text-teal transition-colors duration-300">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </article>
          </Reveal>
        ))}
        <Reveal delay={0.4}>
          <a href="#visit" data-testid="desserts-cta"
            className="group h-full min-h-[16rem] rounded-[2rem] border-2 border-dashed border-gold/50 flex flex-col items-center justify-center gap-4 text-center p-8 hover:bg-gold/10 transition-colors duration-500">
            <p className="font-display italic text-3xl text-gold leading-tight">The full menu<br />awaits in parlour</p>
            <span className="text-xs uppercase tracking-[0.25em] text-cream/70 group-hover:text-gold transition-colors duration-300">Plan your visit</span>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Desserts;
